import { LegalPage, LegalSection, LegalList } from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      eyebrow="Terms"
      title="Terms of Service"
      subtitle="A short set of ground rules for using SalesPit."
      updated="August 6, 2026"
    >
      <LegalSection title="Respect the pit" testid="terms-respect">
        <p>
          SalesPit is a place for real sales reps to practise together. By
          using SalesPit, you agree to treat every partner with respect and
          to keep the platform a safe, professional environment.
        </p>
        <LegalList
          items={[
            "No harassment, hate speech, or abusive behaviour toward any partner.",
            "No spam, unsolicited pitches, or attempts to sell to matched reps.",
            "No illegal activity of any kind while using SalesPit.",
          ]}
        />
      </LegalSection>

      <LegalSection title="You own your conduct" testid="terms-conduct">
        <p>
          You are responsible for your own behaviour on every mock call.
          SalesPit is not a party to the calls you run and does not moderate
          them in real time — treat every session the way you would treat a
          real prospect meeting.
        </p>
      </LegalSection>

      <LegalSection title="Account enforcement" testid="terms-enforcement">
        <p>
          If you violate these terms, we may suspend or permanently remove
          your account. In serious cases (harassment, illegal activity,
          repeated abuse) we reserve the right to act immediately, without
          notice.
        </p>
      </LegalSection>

      <LegalSection title="Availability & changes" testid="terms-availability">
        <p>
          SalesPit is provided <span className="text-white">"as is"</span> as
          it continues to evolve. Features may change, appear or disappear
          while we improve the product. We do our best to keep the platform
          fast, private and available around the clock, but we cannot
          guarantee uninterrupted service.
        </p>
      </LegalSection>

      <LegalSection title="Contact" testid="terms-contact">
        <p>
          Questions about these terms? Reach out at{" "}
          <a
            href="mailto:hello@salespit.io"
            className="text-white underline decoration-[#E52525]/60 decoration-2 underline-offset-4 transition-colors hover:decoration-[#E52525]"
          >
            hello@salespit.io
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
